document.addEventListener('click', (event) => {
  const link = event.target.closest('a[data-curated-anchor]');
  if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const url = new URL(link.href);
  if (url.pathname !== location.pathname) return;
  const target = document.querySelector(url.hash);
  const drawer = link.closest('header-drawer');
  if (!target || !drawer || typeof drawer.closeMenuDrawer !== 'function') return;
  drawer.closeMenuDrawer(event);
  drawer.querySelector('summary').setAttribute('aria-expanded', 'false');
  target.setAttribute('tabindex', '-1');
  target.focus({ preventScroll: true });
});
